import { DisplayBanner } from "../../banner/bannerSlice";

export const moveTeamAccepted = (
  teamName: string,
  newParentTeamName: string
): DisplayBanner => ({
  type: "success",
  header: "The team has been moved successfully",
  content: `${teamName} has been moved under ${newParentTeamName}. This change may take a while to be reflected in Crew and Roster 2.0.`,
  dissmissible: true,
});

export const moveTeamSuccess = (
  teamName: string,
  newParentTeamName: string
): DisplayBanner => ({
  type: "success",
  content: `${teamName} has been moved under ${newParentTeamName} successfully.`,
  dissmissible: true,
});
